import { Order } from '@shared/types';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import { useOrderLink } from '../../../../../../hooks/useOrderLink';
import styles from '../../styles.module.scss';
import ButtonLink from '../../../../../ButtonLink';

type AccessOrderButtonProps = {
    courseKeyword: PublicCourse['keyword'] | null;
    courseSlug: PublicCourse['slug'];
    educatorSlug: PublicEducator['slug'];
    orderId: Order['_id'];
};

export const AccessOrderButton: FunctionComponent<AccessOrderButtonProps> = ({
    courseKeyword,
    courseSlug,
    educatorSlug,
    orderId,
}) => {
    const orderLink = useOrderLink({
        educatorSlug,
        courseSlug,
        orderId,
    });

    return (
        <ButtonLink {...orderLink} preset="primary" className={styles.accessEnrolmentButton}>
            Access {courseKeyword || 'Course'}
        </ButtonLink>
    );
};
